import type { RaspadinhaCampaign } from '@/types/raspadinha-campaign'
import {
  collectCampaignParticipants,
  formatParticipantDateTime,
} from './collect-campaign-participants'
import { buildCampaignCsvFilename, csvEscape, downloadCsvFile } from './csv-export-utils'

export const CAMPAIGN_PARTICIPANTS_CSV_HEADER = [
  'Tipo',
  'Nome',
  'CPF / documento',
  'E-mail',
  'Telefone',
  'Data de participação',
  'Cartelas',
  'Prêmio',
  'Dia contemplado',
  'Horário contemplado',
  'ID interno',
] as const

export function buildCampaignParticipantsCsv(
  campaign: Pick<RaspadinhaCampaign, 'participants' | 'winning_date_schedules'>
): string {
  const rows = collectCampaignParticipants(campaign)

  const lines = [
    CAMPAIGN_PARTICIPANTS_CSV_HEADER.join(','),
    ...rows.map((row) =>
      [
        csvEscape(row.role === 'ganhador' ? 'Ganhador' : 'Participante'),
        csvEscape(row.participant.name),
        csvEscape(row.participant.document),
        csvEscape(row.participant.email),
        csvEscape(row.participant.phone),
        csvEscape(formatParticipantDateTime(row.participant.participated_at)),
        csvEscape(row.participant.tickets_count),
        csvEscape(row.prizeLabel ?? ''),
        csvEscape(row.wonDateLabel ?? ''),
        csvEscape(row.wonTimeLabel ?? ''),
        csvEscape(row.participant.id),
      ].join(',')
    ),
  ]

  return lines.join('\r\n')
}

export function buildCampaignParticipantsCsvFilename(campaignSlug: string): string {
  return buildCampaignCsvFilename('participantes', campaignSlug)
}

export function downloadCampaignParticipantsCsv(
  campaign: Pick<RaspadinhaCampaign, 'participants' | 'winning_date_schedules'>,
  filename: string
): void {
  downloadCsvFile(buildCampaignParticipantsCsv(campaign), filename)
}
